<ng-container *ngIf="note?.dismissedBy?.name" i18n>{{dismissalType}} dismissed by {{ note.dismissedBy.name }} for the following reasons: </ng-container>

<ul *ngIf="note?.dismissalReasons?.length" class="pl-20 mt-5">
  <ng-container *ngFor="let reason of note.dismissalReasons">
    <ng-container [ngSwitch]="reason">
      <li *ngSwitchCase="DPE_DISMISSAL_REASONS.driver_not_at_fault" i18n>
        Driver was not at fault
      </li>
      <li *ngSwitchCase="DPE_DISMISSAL_REASONS.no_unsafe_behavior" i18n>
        No unsafe behavior
      </li>

      <li *ngSwitchCase="DPE_DISMISSAL_REASONS.positive_behavior" i18n>Recognized as positive driving behavior</li>

      <li *ngSwitchDefault>
        {{ reason }}
      </li>
    </ng-container>
  </ng-container>
</ul>
